import { toggle } from "./toggle";

export default toggle("code-enabled");
